import { Grid, Tooltip } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { forwardRef, useEffect } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import i18next from 'i18next';
import AddingButton from '../../AddingButton';
import { createDossierFromTp } from '../../../../containers/thirdparties/thirdparty-sheet/ThirdpartySheetUtils';
import { PrivilegeEnum } from '../../../../services/common/RolesUtils';
import DossiersDataTable from '../../../dossiers/DossiersDataTable';

const DossierSection = forwardRef(({ display,
                          title,
                          fetchThirdpartyInfos,
                          tpVisibleDossCount,
                          thirdpartyActiveDossiers,
                          setTpVisibleDossCount,
                          thirdparty,
                          accountId,
                          history, location,
                          hasAnyOfPrivilegesOnScopedResource
                        }, ref) => {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(thirdpartyActiveDossiers?.length)
  }, [thirdpartyActiveDossiers]);

  return display ? (
    <Grid item xs={12} className={classes.tpItem} id={"dossiers"}>
      <EAAccordion
        title={title}
        logo="dossier"
        counter={
          tpVisibleDossCount !== null
            ? tpVisibleDossCount
            : thirdpartyActiveDossiers?.length
        }
        totalCount={thirdpartyActiveDossiers?.length}
        opened={isExpanded}
        buttons={[
          <Tooltip
            title={
              thirdparty.active
                ? 'Ajouter un dossier'
                : 'Etablissement fermé'
            }
          >
            <div ref={ref}>
              <AddingButton
                label={i18next.t('dossierTable.addBtnLabel')}
                handleClick={() =>
                  createDossierFromTp(
                    accountId,
                    thirdparty,
                    history,
                    location
                  )
                }
                disabled={
                  !(
                    thirdparty.active &&
                    hasAnyOfPrivilegesOnScopedResource(
                      PrivilegeEnum.PRIVILEGE_CREATE_DOSSIER
                    )
                  )
                }
              />
            </div>
          </Tooltip>,
        ]}
      >
        {thirdpartyActiveDossiers && (
          <DossiersDataTable
            dossiers={thirdpartyActiveDossiers}
            monitored
            component="thirdparty"
            pageSize={10}
            multiDataGridPage
            sheetVariant={true}
            onDeactivation={() => fetchThirdpartyInfos()}
            onVisibleRowsCountChange={(count) =>
              setTpVisibleDossCount(count)
            }
            fromTp
          />
        )}
      </EAAccordion>
    </Grid>
  ) : <></>;
})

export default DossierSection;
